<template>
  <div class="status-filter-chips">
    <v-chip
      v-for="option in options"
      :key="option.value"
      :color="value === option.value ? 'primary' : undefined"
      :outlined="value !== option.value"
      class="status-filter-chips__chip"
      @click="$emit('input', option.value)"
    >
      {{ option.title }}
    </v-chip>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { StatusFilterOption } from "@/config/userStatusFilters";

export default defineComponent({
  name: "StatusFilterChips",
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array as PropType<StatusFilterOption[]>,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.status-filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-filter-chips__chip {
  cursor: pointer;
}
</style>
